<template>
  <div>
    <AdvancedSearch
      v-model="advSearch"
      :showExportButton="true"
      :hideSwitch="true"
      :initalSearch="false"
      :searchFields="advancedSearchFields"
      :emitSearchWhenReset="false"
      :emitResetWhenReset="true"
      @search="search"
      @reset="reset"
      @export="$emit('export')" 
    />
  </div>
</template>

<script>
import AdvancedSearch from "@/components/search/Advanced";
import {pageSize} from '@/store/constants'
import { mapGetters } from 'vuex'

const GDPR_HEADERS = [
  {text: 'Fullständiga namn', value: 'person.fullName', sortable: false},
  {text: 'Personnummer', value: 'person.personalNumber', sortable: false},
];

const HEADERS = [
  {text: 'Yrke', value: 'profession.name', sortable: false},
  {text: 'Region', value: 'region.name', sortable: false},
  {text: 'Födelseår', value: 'person.yearOfBirth', sortable: false},
  {text: 'Kön', value: 'person.sex', sortable: false},
  {text: 'Förlängt', value: 'isExtended', sortable: false},
  {text: 'Pausad', value: 'isPaused', sortable: false},
  {text: 'Avbrutna', value: 'isDropped', sortable: false},
];

export default {
  name: 'DeviationsQTStatistics',
  components: {
    AdvancedSearch
  },
  props:{
    schools: { type: Array, default: () => [] }
  },
  
  data: () => ({
    tableConfig: {
      headers: HEADERS,
      options: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: pageSize,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: []
      },
      listEndpoint: 'getDeviationsQTStatistics',
      exportEndpoint: 'exportDeviationsQTStatistics'
    },
    advSearch: {},
  }),

  mounted() {
    this.$emit('tableConfig', this.tableConfig)
  },

  computed: {
    ...mapGetters('basic', ['basicRegions', 'basicProfessions']),
    ...mapGetters('currentuser', ['currentUserRole']),

    canSeePD() {
      return this.currentUserRole === 'registry' || this.currentUserRole === 'admin'
    },

    advancedSearchFields() {
      return {
        regionId: {
          heading: 'Region',
          chipLabel: 'Region',
          label: "Välj regioner att söka bland:",
          items: this.basicRegions.map(o => {return {value: o.id, text: o.name}}),
          type: 'select',
          multiple: true
        },
        professionId: {
          heading: 'Yrke',
          chipLabel: 'Yrke',
          label: "Välj yrken att söka bland:",
          items: this.basicProfessions.map(o => {return {value: o.id, text: o.name}}),
          type: 'select',
          multiple: true
        },
        schoolId: {
          heading: 'Skola',
          chipLabel: 'Skola',
          label: "Välj skola att söka bland:", 
          items: this.schools,
          type: 'autocomplete',
          multiple: true,
          itemText: 'text',
          itemValue: 'value',
        },
        showPersonalData: {
          heading: 'GDPR',
          chipLabel: 'Show personal information',
          label: "Visa personuppgifter",
          type: 'checkbox',
          // disabled: !this.canSeePD,
        }
      }
    }
  },

  methods:{
    search() {
      const headers = [...HEADERS];
      if(this.advSearch && this.advSearch.showPersonalData){
        headers.unshift(...GDPR_HEADERS)
      }
      this.$emit('setHeaders', headers) 
      this.$emit('fetch', this.advSearch)
    },

    reset(){
      this.$emit('setHeaders', HEADERS)
      this.$emit('reset')
    }
  }
}
</script>

<style>

</style>